// 绑定银行卡
const wxRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `bankCard/wx/index${i + 1}`,
  name: `bankCard/wx/Index${i + 1}`,
  component: () => import(`@/views/shopping/bankCard/wx/index${i + 1}.vue`)
}))
const zfbRoutes = Array.from({ length:8 }, (_, i) => ({
  path: `bankCard/zfb/index${i + 1}`,
  name: `bankCard/zfb/Index${i + 1}`,
  component: () => import(`@/views/shopping/bankCard/zfb/index${i + 1}.vue`)
}))

import bankCardIndex from '@/views/shopping/bankCard/index'



export default {
  path: '/shopping',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'bankCard/index',
        name: 'bankCardIndex',
        component: bankCardIndex
      },
    // 绑定银行卡，开始
    ...wxRoutes,
    ...zfbRoutes,

  ],
};
